import { createContext, Dispatch } from 'react';
import { HomeResponse } from 'all-in-one-shared-api';
import type { KeyedMutator } from 'swr';

import { UserAccessActions, lifeHomeActions } from './actions';

export interface UserAccess {
  userAccess?: HomeResponse;
  key?: string;
}
export enum ReminderMessageCategory {
  AGE_65 = 'AGE_65',
  BIRTH_MONTH = 'BIRTH_MONTH',
  NEW_STAFF = 'NEW_STAFF',
  ON_TERMINATION = 'ON_TERMINATION',
}

export interface lifehomeProps {
  policyHolderFirstName: string;
  policyHolderChineseName: string;
  alertsNum: number;
  alertsNumNew: number;
  alertsNum3: number;
  alertsPaymentNum: number;
  alertsPolicyUpdateNum: number;
  alertsClaimUpdateNum: number;
  myPolicies: {
    productCategory: string;
    productCategoryUrl: string;
    productCategoryEn: string;
    productCategoryTC: string;
    productName: string;
    productNameTc: string;
    policyStatusCode: string;
    policyStatus: string;
    policyStatusTc: string;
    alertStateCode: string;
    alertState: string;
    alertStateTc: string;
    policyNumber: string;
    insuredName: string;
    premiumDueDate: string;
    companyCode: string;
    orderNo: string;
    colour: string;
    salesUnitCode: string;
    planCode: string;
    premCessationDate: string;
    alertPolicyUpdateStateCode?: string;
    alertPolicyUpdateState?: string;
    alertPolicyUpdateStateTc?: string;
  }[];
  news: {
    id: number;
    imageUrl: string;
    title: string;
    chineseTitle: string;
    message: string;
    messageCategory?: ReminderMessageCategory; // this property is optional because only Reminder message has it, not News
    chineseMessage: string;
    link: string;
    chineseLink: string;
    publishTime: string; // 新增字段：publishTime
  }[];
}

const HOME_KEY = 'HOME';

export const initialUserAccessValues: UserAccess = {
  userAccess: undefined,
  key: HOME_KEY,
};

export const initialLifeHomeValues: lifehomeProps = {
  policyHolderFirstName: '',
  policyHolderChineseName: '',
  alertsNum: 0,
  alertsNumNew: 0,
  alertsNum3: 0,
  alertsPaymentNum: 0,
  alertsPolicyUpdateNum: 0,
  alertsClaimUpdateNum: 0,
  myPolicies: [],
  news: [],
};

export const HomeContext = createContext<{
  state: UserAccess;
  dispatch: Dispatch<UserAccessActions>;
  mutate?: KeyedMutator<HomeResponse>;
  showTips: boolean;
  setShowTips: (showTips: boolean) => void;
  lifeState?: lifehomeProps;
  lifeMutate?: KeyedMutator<lifehomeProps>;
  lifeDispatch?: Dispatch<lifeHomeActions>;
}>({
  state: initialUserAccessValues,
  dispatch: () => null,
  showTips: true,
  setShowTips: () => {
    //
  },
  lifeState: initialLifeHomeValues,
  lifeDispatch: () => null,
});
